export const environment = {
    production: false,
    managerURL: 'https://kong.dev.i9partner.com.br/ariel-manager-ms',
    keycloackURL: 'https://keycloak.tools.i9partner.com.br/realms/Ariel-dev',
    consultasURL:
        'https://kong.dev.i9partner.com.br/pwa/ariel-consultas-ms/consultations',
    consultasSocketURL: 'https://ariel-consultas.dev.i9partner.com.br',
    consultasSocketPath: '/ws/consultations',
};
